import { render, staticRenderFns } from "./Locate.vue?vue&type=template&id=885b2e5e&scoped=true&"
import script from "./Locate.vue?vue&type=script&lang=js&"
export * from "./Locate.vue?vue&type=script&lang=js&"
import style0 from "./Locate.vue?vue&type=style&index=0&id=885b2e5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "885b2e5e",
  null
  
)

export default component.exports